import {LOCAL_STORAGE_KEYS} from "../utils/constants";
import {invokeApi} from "../bl_libs/invokeApi";
import {use_e2ee} from "../utils/utils";


export const listProductDefinitionsService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    return invokeApi({
        path   : '/admin/pac/products/list',
        method : 'GET',
        headers: { 'Authorization': `Bearer ${token}` }
    }, use_e2ee());
};

export const createProductDefinitionService = (data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/pac/products/create',
        method : 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
    };
    requestObj['postData'] = data;
    return invokeApi(requestObj, use_e2ee());
};

export const updateProductDefinitionService = (data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/pac/products/update',
        method : 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
    };
    requestObj['postData'] = data;
    return invokeApi(requestObj, use_e2ee());
};

export const deleteProductDefinitionService = (product_key) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/pac/products/delete',
        method : 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
    };
    requestObj['postData'] = { product_key };
    return invokeApi(requestObj, use_e2ee());
};

export const getInsiderProductAccessService = (dq_insider_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/pac/insider/get',
        method : 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
    };
    requestObj['postData'] = { dq_insider_id };
    return invokeApi(requestObj, use_e2ee());
};

export const setInsiderOverridesService = (dq_insider_id, overrides) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/pac/insider/set',
        method : 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
    };
    requestObj['postData'] = { dq_insider_id, overrides };
    return invokeApi(requestObj, use_e2ee());
};

export const removeInsiderOverrideService = (dq_insider_id, product_key) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/pac/insider/remove_override',
        method : 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
    };
    requestObj['postData'] = { dq_insider_id, product_key };
    return invokeApi(requestObj, use_e2ee());
};

export const resetInsiderOverridesService = (dq_insider_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/pac/insider/reset',
        method : 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
    };
    requestObj['postData'] = { dq_insider_id };
    return invokeApi(requestObj, use_e2ee());
};

export const getInsiderFeatureAccessService = (dq_insider_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/pac/insider/get_feature',
        method : 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
    };
    requestObj['postData'] = { dq_insider_id };
    return invokeApi(requestObj, use_e2ee());
};

export const setInsiderFeatureOverridesService = (dq_insider_id, overrides) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/pac/insider/set_feature',
        method : 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
    };
    requestObj['postData'] = { dq_insider_id, overrides };
    return invokeApi(requestObj, use_e2ee());
};
